/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import firebase from "../../../config/firebase";
import { Link, withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Table,
  Row,
  Collapse,
  Button,
  ModalBody,
  ModalFooter,
  Modal,
  ModalHeader
} from "reactstrap";
import ReactHTMLParser from "react-html-parser";
import { getCompanyWithId } from "../../../redux/middlewares/Company/getCompany";
import CompanyJobs from "./companyJobs";

// const fromMiliSecondsToDate = seconds => new Date(seconds).toLocaleDateString();

const CompanyDetails = props => {
  const [company, setCompany] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [isOpenStatement, setIsOpenStatement] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const toggleDelete = () => setModal(!modal);

  const callDataFromDB = id => {
    getCompanyWithId(id)
      .then(docs => {
        // console.log(docs);
        if (!docs.empty) {
          setCompany(docs.data());
          setLoading(false);
          // console.log(docs.data());
        }
      })
      .catch(error => console.error(error.message));
  };

  useEffect(() => {
    if (props.company) {
      setCompany(props.company);
      setLoading(false);
    } else {
      const { id } = props;
      // setLoading(true);
      callDataFromDB(id);
    }
    return () => {
      setCompany(undefined);
      setLoading(false);
    };
  }, []);

  // Delete Company
  const deleteHandler = () => {
    // console.log({ company });
    setLoading(true);
    const companyRef = firebase
      .firestore()
      .collection("companies")
      .doc(company.id);
    companyRef
      .delete()
      .then(() => {
        const storage = firebase.storage();
        const logoRef = storage.refFromURL(company.logo);
        const fileRef = storage.ref().child(`${company.email}/${logoRef.name}`);
        // Delete the file
        fileRef
          .delete()
          .then(function() {
            // File deleted successfully
            setLoading(false);
            setModal(false);
            props.history.push("/companies/view-companies");
            alert("Deleted Successfully!");
          })
          .catch(function(error) {
            // Uh-oh, an error occurred!
            alert("Error: " + error.message);
          });
      })
      .catch(err => {
        alert("Error: " + err.message);
      });
  };

  // console.log(company);

  return (
    <React.Fragment>
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            {company && (
              <>
                {/* Company */}
                <Row>
                  <Col md={6}>
                    <div className="card__title">
                      {" "}
                      <h5 className="bold-text">Company Details</h5>
                    </div>
                  </Col>
                  {/* {props?.user.admin === true && (
                    <Col md={6}>
                      <Button color="danger" size="sm" onClick={toggleDelete}>
                        Delete Company
                      </Button>{" "}
                      <Modal isOpen={modal} toggle={toggleDelete}>
                        <ModalHeader toggle={toggleDelete}>Delete</ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this Company ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="danger"
                            onClick={deleteHandler}
                            size="sm"
                            disabled={loading}
                          >
                            {loading ? "Deleting..." : "Delete"}
                          </Button>{" "}
                          <Button
                            color="secondary"
                            onClick={toggleDelete}
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </Col>
                  )} */}
                </Row>

                <Table>
                  <tbody>
                    <tr>
                      <th> Name: </th>
                      <td>
                        <b> {company.name} </b>
                      </td>
                    </tr>
                    <tr>
                      <th style={{ verticalAlign: "middle" }}> Logo: </th>
                      <td>
                        <div style={{ height: "100px", width: "100px" }}>
                          <img
                            src={company.logo}
                            width="100%"
                            height="100%"
                            alt="logo"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th> Email: </th>
                      <td> {company.email} </td>
                    </tr>
                    <tr>
                      <th> Website: </th>
                      <td>
                        <a
                          href={company.websiteURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {company.websiteURL && company.websiteURL}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th> Jobs Posted: </th>
                      <td>
                        {" "}
                        {company.jobsPosted}
                        {/* <Link
                          to={`/jobs/view-jobs/?company=${company.name}&email=${company.email}`}
                          style={{ marginLeft: "10px" }}
                        >
                          View Jobs
                        </Link>{" "} */}
                      </td>
                    </tr>
                    <tr>
                      <th> Company HQ: </th>
                      <td> {company.companyHQ} </td>
                    </tr>
                    <tr>
                      <th> Confirmation Email: </th>
                      <td> {company.confirmationEmail} </td>
                    </tr>
                    <tr>
                      <th> Company Statement: </th>
                      <td>
                        {company.statement && (
                          <div>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() =>
                                setIsOpenStatement(!isOpenStatement)
                              }
                            >
                              View Statement
                            </Button>
                            <Collapse isOpen={isOpenStatement}>
                              <Card>
                                <CardBody>{company.statement}</CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th> Description: </th>
                      <td>
                        {company.description && (
                          <div>
                            <Button color="primary" size="sm" onClick={toggle}>
                              View Description
                            </Button>
                            <Collapse isOpen={isOpen}>
                              <Card>
                                <CardBody>
                                  {ReactHTMLParser(company.description)}
                                </CardBody>
                              </Card>
                            </Collapse>
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {!props.isModalView && <CompanyJobs company={company} />}
              </>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  user: state.authReducer.user
});

export default connect(mapStateToProps)(withRouter(CompanyDetails));
